<template>
  <body>
    <ModalBoletines :boletines="boletines" v-show="modalBoletines"
      @cerrar="cerrarModal"
      @AddBoletin="otroBoletin"
    />
    <aside class="Blk-1">
      <canvas id="canvas1" class="myCanvas"></canvas>
    </aside>
    <aside class="Blk-2">
      <article class="Form">
      <div class="Blk-Campo">
          <p id="titReg">Estado</p>
          <select name="estados" id="" class="campo"
            :disabled = 'habBotAndCamp.hab'
            v-model="estadoSel" @change.prevent="getListaCuevasEstado(estadoSel)">
            <option v-for="estado in estados"
              :key="estado"
              :value="estado">
              {{estado.estado}}
            </option>
          </select>
      </div>
          <div class="Blk-Campo">
          <p id="titReg">Cuevas registradas</p>
          <select name="nomCuevas" id="" class="campo"
            :disabled = 'habBotAndCamp.listCue'
            v-model="cuevaSel" @change.prevent="mostrarDatosCueva(cuevaSel._id)">
            <option v-for="cueva in listaCuevasUp"
              :key="cueva._id"
              :value="cueva">
              {{estadoSel.Abr}}{{cueva.numCat}} - {{cueva.nombre}}
            </option>
          </select>
        </div>
        <form @change="cambioFormCue">
          <div class="Blk-Campo" v-show="verNumCat">
            <p id="titReg">{{estadoSel.Abr}}</p>
            <input name="titulo" class="campo"
                placeholder = "Número de catastro"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="colVista.numCat"
                @blur="validarNumero(colVista.numCat)"
                spellcheck="false"
                autocomplete="off"
              >
          </div>
          <div class="Blk-Campo">
            <p>Nombre</p>
            <input name="titulo" class="campo"
              :disabled = '!habBotAndCamp.hab'
              v-model.trim="colVista.nombre"
              spellcheck="false"
              autocomplete="off"
            >
          </div>
          <div class="Blk-Campo">
            <p>Zona cárstica</p>
            <input type="text" name="ciudad" class="campo"
              v-model.trim="colVista.zonaCarstica"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Latitud N</p>
            <input type="text" name="LatN" class="campo"
              v-model.trim="colVista.coorLatN"
              :disabled = '!habBotAndCamp.hab'
              @blur="coorIntro">
            <p>Longitud W</p>
            <input type="text" name="LonW" class="campo"
              v-model.trim="colVista.coorLonW"
              :disabled = '!habBotAndCamp.hab'
              @blur="coorIntro">
          </div>
          <div class="Blk-Campo">
            <p>UTM N</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="colVista.coorUTMN"
              :disabled = '!habBotAndCamp.hab'>
            <p>UTM E</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="colVista.coorUTME"
              :disabled = '!habBotAndCamp.hab'>
            <p>Zona UTM</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="colVista.zonaUTM"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Plano</p>
            <input type="text" name="pais" class="campo"
              v-model.trim="colVista.plano"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Altitud</p>
            <input type="text" name="altitud" class="campo"
              v-model.trim="colVista.altitud"
              :disabled = '!habBotAndCamp.hab'>
            <p>Boletín</p>
            <select name="boletines" id="" class="campo" v-show="cuevaNueva"
              :disabled = '!habBotAndCamp.hab'
              v-model="colVista.boletin" @change="updateBoletin">
              <option v-for="(boletin, index) in boletines"
                :key="index"
                :value="boletin.Bol">
                {{boletin.Bol}}
              </option>
            </select>
            <input type="text" name="boletin" class="campo" v-show="!cuevaNueva"
              v-model.trim="colVista.boletin"
              :disabled = '!habBotAndCamp.hab'
            >
          </div>
          <!--  ---------------------------------------------------------------------------- -->
          <div class="check0" v-show="verNumCat">
            <p>Añadir boletín</p>
            <button class="botBol" @click.prevent="addBol">+</button>
          </div>
          <!-- --------------------------------------------------------------------------  -->
          <div class="Blk-Campo">
            <p>Localización</p>
            <textarea
              name="local" class="campo"
              v-model.trim="colVista.localizacion"
              :disabled = '!habBotAndCamp.hab'>
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Desarrollo</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="colVista.desarrollo"
              :disabled = '!habBotAndCamp.hab'>
            <p>Desnivel</p>
            <input type="text" name="editorial" class="campo"
              v-model.trim="colVista.desnivel"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Participantes</p>
            <textarea
              name="topo" class="campo"
              v-model.trim="colVista.topo"
              :disabled = '!habBotAndCamp.hab'>
            </textarea>
          </div>
          <div class="Blk-Campo">
            <p>Grupo(s)</p>
            <input type="text" name="grupos" class="campo"
              v-model.trim="colVista.grupos"
              :disabled = '!habBotAndCamp.hab'>
            <p>Precisión</p>
            <input type="text" name="Precision" class="campo"
              autocomplete="off"
              v-model.trim="colVista.grado"
              :disabled = '!habBotAndCamp.hab'>
          </div>
          <div class="Blk-Campo">
            <p>Fecha</p>
            <input type="text" name="fecha" class="campo"
              v-model.trim="colVista.fechaExp"
              :disabled = '!habBotAndCamp.hab'>
            <div class="check">
              <p>Antropología</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="colVista.arq">
            </div>
            <div class="check">
              <p>Guácharos</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="colVista.gua">
            </div>
            <div class="check">
              <p>Información reservada</p>
              <input type="checkbox" name="privado"
                :disabled = '!habBotAndCamp.hab'
                v-model.trim="colVista.reservado">
            </div>
          </div>
           <div class="Blk-Campo">
            <p>Comentarios</p>
            <textarea
              name="topo" class="campo"
              v-model.trim="colVista.comment"
              :disabled = '!habBotAndCamp.hab'>
            </textarea>
          </div>
          <div class="quitaSaltoLineas">
            <button @click.prevent="noLineBreaks"
              :disabled = '!habBotAndCamp.hab'
              class="Btn-BRL">
              Borrar saltos de línea en Localiz. y Coment.
            </button>
          </div>
          <div class="BtnImg">
            <input type="file"
              name="file-1" id="file-1"
              :disabled = '!habBotAndCamp.hab'
              class="inputfile" @change="cargarPortada"/>
            <label for="file-1" ><span class="icon-icoSubirImg"></span></label>
            <p id="eti">Cargar topo</p>
          </div>
          <img class="imgRecorte2" :src="colVista.imgRecorte">
        </form>
      </article>
      <aside class="Btns">
        <BotonesCRUD
        :desacMas="!habBotAndCamp.actMas"
        :desacEdit="!habBotAndCamp.actEdi"
        :desacMenos="!habBotAndCamp.actMen"
        :desacSave="!habBotAndCamp.actSav"
        @nuevo="nuevaCueva"
        @editar="editarCueva"
        @del="borrarCueva"
        @save="saveCueva"
        />
        <div class="Btn-CyP">
          <div class="copyDat">
            <p @click="copyData">Copy</p>
          </div>
          <div class="pasteDat">
            <p @click="pasteData">Pega</p>
          </div>
        </div>
      </aside>
    </aside>
  </body>
</template>

<script>
import { mapState } from 'vuex' // en Computed está ...mapState(['usuarioEnSesion'])
import axios from 'axios'
import BotonesCRUD from '../components/BotonesCRUD.vue'
import ModalBoletines from '../components/ModalBoletines.vue'
import estados from '../assets/JSON/estados.json' // Lista de estados en archivo interno
import boletines from '../assets/JSON/BSVE.json' // Lista de boletines en archivo interno
export default {
  name: 'FormCatastro',
  components: { BotonesCRUD, ModalBoletines },
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.token = this.usuarioEnSesion.tokenUser
    this.activaModo('Zero')
    this.estados = estados.filter(e => e.Abr !== '0')
    this.boletines = boletines.sort(function (a, b) {
      if (a.anyo > b.anyo) { return 1 }
      if (a.anyo < b.anyo) { return -1 }
      return 0
    })
  },
  data () {
    return {
      estadoSel: [],
      cuevaSel: [],
      estadoSelBkUp: [],
      cuevaSelBkUp: [],
      estados: [],
      boletines: [],
      listaCuevas: [],
      listaCuevasBkUp: {},
      colVista: {},
      colVistaBkUp: {},
      habBotAndCamp: {
        actMas: false,
        actEdi: false,
        actMen: false,
        actSav: false,
        hab: false,
        listCue: true
      },
      URLbase: '',
      token: '',
      verNumCat: false,
      IsModoSalirMas: false,
      IsModoSalirEdi: false,
      copyRegistro: {},
      otroBol: false,
      bolAnterior: '',
      bolAux: '',
      cuevaNueva: false,
      modalBoletines: false
    }
  },
  methods: {
    getListaCuevasEstado (estadoSel) {
      try {
        const url = `${this.URLbase}/cuevas/listCuevas`
        axios.post(url, { abrEst: estadoSel.Abr }, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            const listCuevas = result.data
            this.listaCuevas = listCuevas
          })
          .catch(error => console.log(error))
        this.activaModo('INI')
        this.habBotAndCamp.listCue = false
      } catch (error) {
        alert(error)
      }
      this.colVista.abrEst = this.estadoSel.Abr
      this.blanquearCuevaVista()
    },
    mostrarDatosCueva (IdCueva) {
      this.getDatosCueva(IdCueva)
      this.activaModo('Sel')
      this.habBotAndCamp.listCue = false
    },
    async getDatosCueva (IdCueva) {
      try {
        const url = `${this.URLbase}/cuevas/getCuevaData`
        const idCueva = { _id: IdCueva }
        axios.post(url, idCueva)
          .then(result => {
            const dataCueva = result.data
            this.colVista = dataCueva
            this.dibujarPosicion(this.colVista.coorLonW, this.colVista.coorLatN)
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
    },
    editarCueva () {
      this.IsModoSalirEdi = !this.IsModoSalirEdi
      // Si es modo edición, hace copia de los datos actuales por si se cancela
      if (this.IsModoSalirEdi) {
        this.colVistaBkUp = JSON.parse(JSON.stringify(this.colVista))
        this.estadoSelBkUp = JSON.parse(JSON.stringify(this.estadoSel))
        this.cuevaSelBkUp = JSON.parse(JSON.stringify(this.cuevaSel))
        this.listaCuevasBkUp = JSON.parse(JSON.stringify(this.listaCuevas))
        // this.verNumCat = true
        this.activaModo('EDI')
      } else {
        // Si se cancela, restaura los valores previos
        this.colVista = this.colVistaBkUp
        this.colVista.abrEst = this.estadoSel.Abr
        this.estadoSel = this.estadoSelBkUp
        this.cuevaSel = this.cuevaSelBkUp
        this.listaCuevas = this.listaCuevasBkUp
        this.activaModo('Sel')
        this.habBotAndCamp.listCue = false
        // this.verNumCat = false
      }
    },
    cambioFormCue () {
      // console.log('IsModoSalirMas: ' + this.IsModoSalirMas)
      // console.log('IsModoSalirEdi: ' + this.IsModoSalirEdi)
      if (this.IsModoSalirMas && !!this.minData) {
        this.activaModo('MASs')
      } else {
        this.activaModo('MAS')
      }
      if (this.IsModoSalirEdi && this.minData) {
        this.activaModo('EDIs')
      }
    },
    async borrarCueva () {
      const response = await this.$root.alertJoa(
        'Estás a punto de borrar el registro de esta cueva. Esta acción no puede revertirse ¿Quieres continuar?',
        'W', 'C'
      )
      if (response === 'borrar') {
        try {
          const url = `${this.URLbase}/cuevas/borrarCueva`
          const cuevaId = { _id: this.colVista._id }
          axios.post(url, cuevaId, {
            headers: {
              authorization: this.token
            }
          })
            .then(result => {
              switch (result.status) {
                case 200:
                  this.blanquearCuevaVista()
                  this.alertJoa('¡Registro borrado con éxito!', 'S')
                  this.getListaCuevasEstado(this.estadoSel)
                  break
                case 500:
                  this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
                  break
                default:
                  this.alertJoa('Algo salió mal, intenta otra vez', 'E')
              }
            })
            .catch(error => {
              console.log(error)
              this.alertJoa('Error al borrar registro, intenta otra vez', 'E')
            })
        } catch (error) {
          alert(error)
        }
      }
    },
    async saveCueva () {
      try {
        const url = `${this.URLbase}/cuevas/save`
        this.colVista.abrEst = this.estadoSel.Abr
        const cuevaData = this.colVista
        axios.post(url, cuevaData, {
          headers: {
            authorization: this.token
          }
        })
          .then(result => {
            if (result.data === 'success') {
              this.alertJoa('Datos guardados', 'S')
            } else {
              this.alertJoa('Error guardando los datos, intenta otra vez', 'E')
            }
            this.getListaCuevasEstado(this.estadoSel)
          })
          .catch(error => console.log(error))
      } catch (error) {
        alert(error)
      }
      this.IsModoSalirMas = false
      this.IsModoSalirEdi = false
      this.blanquearCuevaVista()
      this.activaModo('INI')
      this.habBotAndCamp.listCue = false
      this.borrarPuntos()
    },
    nuevaCueva () {
      this.IsModoSalirMas = !this.IsModoSalirMas
      if (this.IsModoSalirMas) {
        this.colVistaBkUp = JSON.parse(JSON.stringify(this.colVista))
        this.estadoSelBkUp = JSON.parse(JSON.stringify(this.estadoSel))
        this.cuevaSelBkUp = JSON.parse(JSON.stringify(this.cuevaSel))
        this.listaCuevasBkUp = JSON.parse(JSON.stringify(this.listaCuevas))
        // this.cuevaNueva = true
        // this.verNumCat = true
        this.blanquearCuevaVista()
        this.activaModo('MAS')
        // this.setFocus()
      } else {
        this.activaModo('INI')
        // this.cuevaNueva = false
        this.blanquearCuevaVista()
        this.colVista.abrEst = this.estadoSel.Abr
        this.estadoSel = this.estadoSelBkUp
        this.cuevaSel = this.cuevaSelBkUp
        this.listaCuevas = this.listaCuevasBkUp
        if (this.cuevaSel.nombre) {
          this.colVista = JSON.parse(JSON.stringify(this.colVistaBkUp))
          this.activaModo('Sel')
          this.habBotAndCamp.listCue = false
        } else {
          this.activaModo('INI')
          this.habBotAndCamp.listCue = false
        }
      }
      this.borrarPuntos()
    },
    validarNumero (numero) {
      if (this.listaCuevas.some(n => n.numCat === Number(numero))) {
        this.alertJoa('¡Atención! La cueva ' + this.estadoSel.Abr + numero + ' ya está registrada', 'W')
        this.colVista.numCat = ''
      }
      this.cambioFormCue()
    },
    blanquearCuevaVista () {
      this.colVista = {}
      this.cuevaSel = []
    },
    otroBoletin (boletinRecibido) {
      this.colVista.boletin = `${this.colVista.boletin}, ${boletinRecibido}`
    },
    addBol () {
      this.modalBoletines = true
    },
    cerrarModal () {
      this.modalBoletines = false
    },
    // cargarPortada (event) {        PODRÍA UTILIZARSE PARA CARGAR TOPOS EN SU MOMENTO
    //   // Asignamos la imagen a nuestra data
    //   const portada = event.target.files[0]
    //   // Si imagen > 500kB alertamos y salimos
    //   const tamaño = portada.size
    //   if (tamaño > 500000) {
    //     alert('El tamaño del archivo es: ' +
    //     Math.round(tamaño / 1000) +
    //     'kb. Por favor, selecciona un archivo de un tamaño menor a 500 kb')
    //   } else {
    //     // Cargamos la previsualización
    //     const reader = new FileReader()
    //     reader.readAsDataURL(portada)
    //     reader.onload = e => { this.hemeroVista.imgRecorte = e.target.result }
    //   }
    // },
    activaModo (modo) {
      switch (modo) {
        case 'INI':
          this.confModo = [1, 0, 0, 0, 0]
          this.verNumCat = false
          break
        case 'Sel':
          this.confModo = [1, 1, 1, 0, 0]
          this.verNumCat = false
          break
        case 'MAS':
          this.confModo = [1, 0, 0, 0, 1]
          this.verNumCat = true
          break
        case 'MASs':
          this.confModo = [1, 0, 0, 1, 1]
          break
        case 'EDI':
          this.confModo = [0, 1, 0, 0, 1]
          this.verNumCat = true
          break
        case 'EDIs':
          this.confModo = [0, 1, 0, 1, 1]
          break
        case 'Zero':
          this.confModo = [0, 0, 0, 0, 0]
          break
      }
      let i = 0
      for (const key in this.habBotAndCamp) {
        this.confModo[i] === 0
          ? this.habBotAndCamp[key] = false
          : this.habBotAndCamp[key] = true
        i++
      }
    },
    borraPosicion (pos) {
      this.indice = this.indice.slice(0, pos).concat(this.indice.slice(pos + 1))
    },
    copyData () {
      this.copyRegistro = JSON.parse(JSON.stringify(this.colVista))
      delete this.copyRegistro._id
      delete this.copyRegistro.numCat
    },
    pasteData () {
      this.colVista = this.copyRegistro
      this.copyRegistro = {}
    },
    comparaNumCat (a, b) {
      if (a.numCat > b.numCat) {
        return -1
      }
      if (a.numCat < b.numCat) {
        return 1
      } else {
        return 0
      }
    },
    coorIntro () {
      // if (this.colVista.coorLatN !== '' && this.colVista.coorLonW !== '') {
      this.dibujarPosicion(this.colVista.coorLonW, this.colVista.coorLatN)
      // }
    },
    dibujarPosicion (w, n) {
      if (!(w || n)) { return }
      const x = Number(w.substr(0, 2)) + (Number(w.substr(4, 2))) / 60 + (Number(w.substr(8, 2))) / 3600
      const y = Number(n.substr(0, 2)) + (Number(n.substr(4, 2))) / 60 + (Number(n.substr(8, 2))) / 3600
      const A = -73.4166666667
      const B = -59.8027777778
      const C = 12.1894444444
      const D = 0.84311111111
      const myCanvas = document.getElementById('canvas1')
      const ancho = myCanvas.width
      myCanvas.height = ancho * 0.8578569
      // document.getElementById('canvas1').style.height = ancho * 0.8578569
      const alto = myCanvas.height
      var ctx = myCanvas.getContext('2d')
      const xP = ((-x - A) / (B - A)) * ancho
      const yP = ((y - C) / (D - C)) * alto
      ctx.fillStyle = 'rgb(250,0,0)'
      ctx.beginPath()
      ctx.arc(xP, yP, 2, 0, 2 * Math.PI)
      ctx.fill()
    },
    borrarPuntos () {
      const myCanvas = document.getElementById('canvas1')
      const ancho = myCanvas.width
      const alto = ancho * 0.8578569
      var ctx = myCanvas.getContext('2d')
      ctx.clearRect(0, 0, ancho, alto)
    },
    noLineBreaks () {
      this.colVista.localizacion = this.colVista.localizacion.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.colVista.localizacion = this.colVista.localizacion.replaceAll('  ', ' ')
      this.colVista.comment = this.colVista.comment.replaceAll(/(\r\n|\r|\n)/g, ' ')
      this.colVista.comment = this.colVista.comment.replaceAll('  ', ' ')
      this.cambioFormCue()
    }
  },
  computed: {
    minData () {
      return (this.colVista.nombre && this.estadoSel.Abr && this.colVista.numCat)
    },
    listaCuevasUp () {
      let aux = this.listaCuevas
      aux = aux.sort((a, b) => a.numCat - b.numCat)
      return aux
    },
    ...mapState(['usuarioEnSesion'])
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.myCanvas {
  background-image: url('../assets/mapa_de_venezuela.svg');
  background-size: cover;
  margin-top: 40px;
}
body {
  width: 100vw;
  height: 82vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
aside.Blk-1 {
  width: 20%;
  background-color: var(--az-cl-tr08);
  border: solid 0.5px var(--az-cl-tr08);
}
.imgRecorte{
  margin-top: 75px;
  width:80%;
  justify-self: center;
  /* box-shadow: rgb(53, 52, 52) 5px 5px 7px; */
}
#canvas1{
  width: 90%;
  aspect-ratio: 1.165695583960448;
}
.imgRecorte2{
  display:none;
}
aside.Blk-2 {
  width: 80%;
  display: grid;
  grid-template-columns: 80% 20%;
  background-color: var(--gr-fo-for);
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 1.5%;
}
article.Form {
  color: rgb(47, 79, 79);
  padding-top: 20px;
}
.Btns {
  /* display: grid; */
  padding-left: 20px;
  padding-top: 20px;
  position: sticky; /* no funciona */
}
.formInd{
  margin-top: 55px;
}
.formIndTel{
  display:none;
}
.Blk-Campo{
  width: 100%;
  /* flex:20; */
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 4px;
}
.Blk-Campo p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  max-width: 90px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.campo{
  height: auto;
  min-height: 26px;
  width: auto;
  min-width: 70px;
  /* margin-left: 10px; */
  padding-left: 8px;
  background-color: var(--gr-fo-cam);
  border: var(--bo-cam);
  border-radius: 3px;
  font-size: 15px;
  color: var(--tx-cam);
  flex: 2;
  text-align: left;
}
.campo:focus{
  outline-color: var(--az-ico);
}
.check{
  display: flex;
  margin-top: 2%;
}
.check0{
  display: flex;
  margin-top: 1px;
  justify-content: flex-end;
  padding-right: 0;
  /* border:1px solid darkorange; */
}
.check, .check0 p {
  color: black;
  font-weight: normal;
  font-size: 13px;
  text-align: left;
  padding-left: 18px;
  padding-right: 4px;
  max-width: 150px;
  min-width: 90px;
  margin-bottom: 2px;
  line-height: 98%;
}
.botBol{
  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  height: 18px;
  width: 18px;
  font-size: 18px;
  background-color: #2878F0;
  font-weight: 700;
  border-radius: 3px;
  border: 0;
  color: white;
  margin-left: 2px;
  padding-bottom: 2px;
}
#titReg{
  font-weight: bold;
}

.BtnImg{
  display:flex;
  align-items: center;
}
.BtnImg p{
  color:black;
  font-size: 13px;
  padding-top: 4px;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: relative;
  /* z-index: -1; *****/
  visibility:hidden;
}
/*Esta clase da el formato al boton y la etiqueta */
.inputfile + label {
  /* width: 63.5%;  */
  cursor: pointer;
  padding: 5px;
  text-align: left;
  margin-bottom: 6px;
  margin-top: 6px;
  color: black;
  font-size: 16px;
}
.inputfile + label:hover {
  transform: scale(1.08);
  /* background-color: rgb(192, 205, 206); */
  /* .inputfile:focus + label, .inputfile.has-focus + label,*/
}
.inputfile:disabled + label {
  color: #8fa3ad;
}
.icon-icoSubirImg {
  color: var(--az-ico);
  font-size: 1.45em;
  padding-left: 9px;
  padding-right: 9px;
}
input[type=checkbox] {
  transform: scale(1.2);
}
.copyDat, .pasteDat{
  margin-top: 30px;
  background-color: rgb(116, 182, 248);
  border: none;
  width: 40%;
  height: 25px;
  color: var(--az-ico);
  font-size: 14px;
  line-height: 150%;
  margin-left: auto;
  margin-right: auto;
}
.pasteDat{
  margin-top: 5px;
  background-color: rgb(255, 204, 137);
}
.copyDat:hover, .pasteDat:hover{
  cursor: pointer;
}
.quitaSaltoLineas{
  /* border: solid 1px orange; */
  display: flex;
  justify-content: flex-end;
}
.Btn-BRL{
  /* justify-content: flex-end; */
  font-size: 11px;
  margin-top: 2px;
}
@media screen and (max-width: 575px){
  body {
    width: 100vw;
    /* height: auto; */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .Blk-1{
    display: none;
  }
  aside.Blk-2 {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    align-items: stretch;
  }
  article.Form {
    padding-top: 5px;
    overflow: scroll;
  }
  .Blk-Campo {
    flex-direction: column;
    /* align-items:flex-start; */
    align-items:stretch;
  }
  .Blk-Campo p{
    max-width: 190px;
  }
  .campo{
    /* width: 100% no funciona, el ancho se controla con align-items: strech en .Blk-Campo*/
    margin: 0 2% 0 2%;
  }
  .check{
    width: 43%;
    justify-content: space-between;
    margin-top: 6px;
    /* border: solid 1px orange; */
  }
  aside.Btns {
    padding: 0 2.5% 3% 2.5%;
  }
  .formInd{
    display: none;
  }
  .formIndTel{
    display: block;
    align-self: end;
    margin-right: 2%;
  }
  textarea {
    resize: none;
  }
  .imgRecorte2{
    display:inline-flex;
    width: 65%;
    margin-top: 5px;
    margin-bottom:15px;
    justify-self: center;
    box-shadow: rgb(53, 52, 52) 5px 5px 7px;
  }
  .Btn-CyP{
    width: 50%;
    display: inline-flex;
    row-gap: 4px;
    justify-items: right;
    /* border: solid 1px orangered; */
  }
  .copyDat, .pasteDat{
    margin-top: 10px;
    border: none;
    /* width: 25%; */
    height: 25px;
    color: var(--az-ico);
    font-size: 14px;
    line-height: 150%;
    margin-left: 3px;
  }
}
</style>
